import { PaymentUtilService } from './../../services/payment-util/payment-util.service';
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ICart } from '../../models/cart.model';

@Component({
  selector: 'app-paytm',
  templateUrl: './paytm.component.html',
  styleUrls: ['./paytm.component.scss']
})
export class PaytmComponent implements OnInit {

  @Input() option;
  @Input() cartDetails: ICart;
  @Input() isOrderLoading;
  @Input() qrCodeUrl;
  @Output() dataEmit: EventEmitter<any> = new EventEmitter();
  constructor(
    public paymentUtilService: PaymentUtilService
  ) { }

  ngOnInit() {
  }

  /**On click event of payment */
  submitPayTm() {
    const data = {
      'mode': 'PAYTM',
      'mode_value': 'PAYTM',
    };
    this.dataEmit.emit(data);
  }

}
